const API_BASE_URL = 'https://wonderent.wonderchef.com';

document.addEventListener('DOMContentLoaded', function() {
    // At the start of the file
    if (typeof API_BASE_URL === 'undefined') {
        console.error('API_BASE_URL is not defined');
        throw new Error('API_BASE_URL is required but not defined');
    }

    // Add CSS dynamically
    const styles = `
        .page-width {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 20px;
        }

        .rental-return-container {
            padding: 2rem 0;
        }

        .return-form-card {
            background: white;
            border-radius: 12px;
            padding: 2rem;
            max-width: 600px;
            margin: 2rem auto;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }

        .return-title {
            text-align: center;
            margin-bottom: 1rem;
        }

        .return-description {
            text-align: center;
            color: #666;
            margin-bottom: 2rem;
        }

        .form-group {
            margin-bottom: 1.5rem;
        }

        .question {
            font-weight: bold;
            margin-bottom: 1rem;
        }

        .radio-group {
            display: flex;
            gap: 2rem;
            margin-bottom: 1rem;
        }

        .radio-option {
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }

        .address-box {
            background: #f8f8f8;
            padding: 1rem;
            border-radius: 8px;
            margin-top: 1rem;
        }

        .form-input {
            width: 100%;
            padding: 0.8rem;
            border: 1px solid #ddd;
            border-radius: 4px;
            margin-top: 0.5rem;
        }

        .submit-button {
            background: #E31837;
            color: white;
            width: 100%;
            padding: 1rem;
            border: none;
            border-radius: 8px;
            font-size: 1.1rem;
            cursor: pointer;
            transition: background-color 0.3s;
            margin-top: 2rem;
        }

        .submit-button:hover {
            background: #c41530;
        }

        .submit-button:disabled {
            background: #999;
            cursor: not-allowed;
        }

        .note {
            text-align: center;
            color: #666;
            font-size: 0.9rem;
            margin-top: 1rem;
        }

        .initiate-return-btn {
            display: block;
            width: 100%;
            max-width: 400px;
            margin: 1.5rem auto;
            padding: 1rem 2rem;
            background: #E31837;
            color: white;
            border: none;
            border-radius: 8px;
            font-size: 1.1rem;
            font-weight: 500;
            cursor: pointer;
            transition: background-color 0.3s ease;
            text-align: center;
        }

        .initiate-return-btn:hover {
            background: #c41530;
        }

        .initiate-return-btn:disabled {
            background: #999;
            cursor: not-allowed;
        }

        .qc-drawer {
            position: fixed;
            top: 0;
            right: -100%;
            width: 100%;
            max-width: 500px;
            height: 100vh;
            background: white;
            box-shadow: -2px 0 10px rgba(0,0,0,0.1);
            transition: right 0.3s ease;
            z-index: 1000;
        }

        .qc-drawer.open {
            right: 0;
        }

        .drawer-content {
            height: 100%;
            display: flex;
            flex-direction: column;
        }

        .drawer-header {
            padding: 1.5rem;
            border-bottom: 1px solid #eee;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .close-drawer {
            background: none;
            border: none;
            font-size: 1.5rem;
            cursor: pointer;
            padding: 0.5rem;
        }

        .drawer-body {
            padding: 1.5rem;
            flex: 1;
            overflow-y: auto;
        }

        .upload-section {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
            gap: 20px;
            padding: 20px;
        }

        .upload-box {
            border: 2px dashed #ccc;
            border-radius: 8px;
            padding: 15px;
            text-align: center;
            min-height: 150px;
            position: relative;
        }

        .upload-placeholder p {
            margin-top: 10px;
        }

        .upload-placeholder p:after {
            content: '*';
            color: red;
            margin-left: 2px;
        }

        #defectImageBox .upload-placeholder p:after,
        #additionalImageBox .upload-placeholder p:after {
            content: '';
        }

        .preview-container {
            position: relative;
        }

        .preview-container img {
            max-width: 100%;
            border-radius: 4px;
        }

        .remove-image {
            position: absolute;
            top: -10px;
            right: -10px;
            background: #E31837;
            color: white;
            border: none;
            border-radius: 50%;
            width: 24px;
            height: 24px;
            cursor: pointer;
        }

        .upload-actions {
            margin-top: 2rem;
            text-align: center;
        }

        .submit-upload {
            background: #E31837;
            color: white;
            border: none;
            border-radius: 8px;
            padding: 1rem 2rem;
            font-size: 1.1rem;
            cursor: pointer;
            transition: background-color 0.3s ease;
        }

        .submit-upload:hover {
            background: #c41530;
        }

        .success-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.5);
            display: none;
            justify-content: center;
            align-items: center;
            z-index: 1100;
        }

        .success-overlay.show {
            display: flex;
        }

        .success-content {
            background: white
        }

        .steps-list {
            margin: 2rem 0;
        }

        .step {
            display: flex;
            align-items: center;
            margin-bottom: 1rem;
        }

        .step-icon {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background: #E31837;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 1rem;
        }

        .step-text {
            font-size: 1rem;
            color: #333;
        }

        .support-text {
            text-align: center;
            margin-top: 2rem;
            color: #666;
        }

        .support-text a {
            color: #E31837;
            text-decoration: none;
        }

        .support-text a:hover {
            text-decoration: underline;
        }

        .status-return {
            color: #E31837;
            font-weight: bold;
        }
    `;

    // Add styles to head
    const styleSheet = document.createElement("style");
    styleSheet.textContent = styles;
    document.head.appendChild(styleSheet);

    // Get URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const rentalId = urlParams.get('rental_id')?.replace('RNT', '');
    const email = urlParams.get('email');

    // Debug logs
    console.log('URL Parameters:', {
        originalRentalId: urlParams.get('rental_id'),
        processedRentalId: rentalId,
        email: email
    });

    // Validate parameters
    if (!rentalId || !email) {
        console.error('Missing required parameters:', { rentalId, email });
        const container = document.querySelector('.rental-return-container');
        if (container) {
            container.innerHTML = `
                <div class="return-form-card">
                    <h1 class="return-title">Error</h1>
                    <p class="return-description">Invalid request. Please try again from your rental dashboard.</p>
                    <a href="/pages/rental-dashboard" class="submit-button">Return to Dashboard</a>
                </div>
            `;
        }
        return;
    }

    console.log('Fetching details for order:', rentalId); // Debug log
    fetchOrderDetails(rentalId, email);

    async function fetchOrderDetails(rentalId, email) {
        const container = document.querySelector('.rental-return-container');
        
        try {
            const url = `${API_BASE_URL}/api/rentals/customer/public/return/${rentalId}/?email=${encodeURIComponent(email)}`;
            console.log('Making request to:', url);
            
            // First make an OPTIONS request
            const optionsResponse = await fetch(url, {
                method: 'OPTIONS',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Origin': window.location.origin
                },
                mode: 'cors'
            });

            if (!optionsResponse.ok) {
                console.error('OPTIONS request failed:', optionsResponse.status);
            }

            // Then make the actual GET request
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Origin': window.location.origin
                },
                mode: 'cors'
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log('Received data:', data);

            // Show the return form
            showReturnForm(data);

        } catch (error) {
            console.error('Fetch error details:', {
                message: error.message,
                stack: error.stack,
                url: `${API_BASE_URL}/api/rentals/customer/public/return/${rentalId}/?email=${encodeURIComponent(email)}`
            });
            
            if (container) {
                container.innerHTML = `
                    <div class="return-form-card">
                        <h1 class="return-title">Error</h1>
                        <p class="return-description">Failed to load rental details. Please try again.</p>
                        <p class="error-message">${error.message}</p>
                        <button onclick="window.location.reload()" class="submit-button">Try Again</button>
                    </div>
                `;
            }
        }
    }

    function showReturnForm(data) {
        console.log('Rendering return form with data:', data);
        const container = document.querySelector('.rental-return-container');
        
        const formHTML = `
            <div class="return-form-card">
                <h1 class="return-title">Initiate Return</h1>
                <p class="return-description">If you wish to return your rented product, please submit the below details.</p>
                
                <div class="form-group">
                    <strong>Product:</strong> ${data.product_name}
                </div>
                
                <form id="returnForm" data-rental-id="${data.rental_id}">
                    <div class="form-group">
                        <p class="question">1. Is your pick-up location the same as your delivery location?</p>
                        <div class="radio-group">
                            <label class="radio-option">
                                <input type="radio" name="sameAddress" value="yes" checked>
                                <span>Yes</span>
                            </label>
                            <label class="radio-option">
                                <input type="radio" name="sameAddress" value="no">
                                <span>No</span>
                            </label>
                        </div>
                        
                        <div class="address-box" id="existingAddress">
                            <div>${data.delivery_address?.name || 'Not Available'}</div>
                            <div>${data.delivery_address?.phone || 'Not Available'}</div>
                            <div>${data.delivery_address?.address || 'Not Available'}</div>
                        </div>
                        
                        <div id="newAddressForm" style="display: none;">
                            <input type="text" class="form-input" name="name" placeholder="Name">
                            <input type="text" class="form-input" name="address" placeholder="Complete Address">
                            <input type="tel" class="form-input" name="contact" placeholder="Contact Number">
                        </div>
                    </div>

                    <div class="form-group">
                        <p class="question">2. Please confirm if you have the original packaging of the product.</p>
                        <div class="radio-group">
                            <label class="radio-option">
                                <input type="radio" name="hasPackaging" value="yes" checked>
                                <span>Yes</span>
                            </label>
                            <label class="radio-option">
                                <input type="radio" name="hasPackaging" value="no">
                                <span>No</span>
                            </label>
                        </div>
                    </div>

                    <button type="submit" class="submit-button">Submit Return Request</button>
                </form>
                
                <p class="note">Our team will contact you to schedule the pickup after submission.</p>
            </div>
        `;

        container.innerHTML = formHTML;

        // Initialize form handlers with the complete data object
        setupFormHandlers(data.rental_id, {
            delivery_address: {
                name: data.delivery_address?.name || 'Not Available',
                phone: data.delivery_address?.phone || 'Not Available',
                address: data.delivery_address?.address || 'Not Available'
            },
            ...data
        });
    }

    function setupFormHandlers(rentalId, deliveryData) {
        const form = document.getElementById('returnForm');
        const sameAddressRadios = form.querySelectorAll('input[name="sameAddress"]');
        const existingAddress = document.getElementById('existingAddress');
        const newAddressForm = document.getElementById('newAddressForm');

        // Store the original delivery data
        const originalAddress = {
            name: deliveryData?.delivery_address?.name,
            phone: deliveryData?.delivery_address?.phone,
            address: deliveryData?.delivery_address?.address
        };

        // Toggle address form visibility and required fields
        sameAddressRadios.forEach(radio => {
            radio.addEventListener('change', (e) => {
                const newAddressInputs = newAddressForm.querySelectorAll('input');
                
                if (e.target.value === 'yes') {
                    // Check if existing address has all required fields
                    if (!originalAddress.name || !originalAddress.phone || !originalAddress.address || 
                        originalAddress.name === 'Not Available' || 
                        originalAddress.phone === 'Not Available' || 
                        originalAddress.address === 'Not Available') {
                        alert('Existing address is incomplete. Please provide a new address.');
                        // Auto-select "No" option
                        form.querySelector('input[name="sameAddress"][value="no"]').checked = true;
                        existingAddress.style.display = 'none';
                        newAddressForm.style.display = 'block';
                        newAddressInputs.forEach(input => input.setAttribute('required', ''));
                    } else {
                        existingAddress.style.display = 'block';
                        newAddressForm.style.display = 'none';
                        newAddressInputs.forEach(input => input.removeAttribute('required'));
                    }
                } else {
                    existingAddress.style.display = 'none';
                    newAddressForm.style.display = 'block';
                    newAddressInputs.forEach(input => input.setAttribute('required', ''));
                }
            });
        });

        // Handle form submission
        form.addEventListener('submit', async (e) => {
            e.preventDefault();
            const button = form.querySelector('button[type="submit"]');
            button.disabled = true;
            button.textContent = 'Processing...';

            const formData = {
                same_address: form.querySelector('input[name="sameAddress"]:checked').value === 'yes',
                has_packaging: form.querySelector('input[name="hasPackaging"]:checked').value === 'yes'
            };

            try {
                if (!formData.same_address) {
                    // Validate new address fields
                    const name = form.querySelector('input[name="name"]').value.trim();
                    const address = form.querySelector('input[name="address"]').value.trim();
                    const contact = form.querySelector('input[name="contact"]').value.trim();
                    
                    if (!name || !address || !contact) {
                        alert('Please fill in all address fields');
                        button.disabled = false;
                        button.textContent = 'Submit Return Request';
                        return;
                    }
                    
                    // Basic phone validation
                    if (!/^\d{10}$/.test(contact)) {
                        alert('Please enter a valid 10-digit phone number');
                        button.disabled = false;
                        button.textContent = 'Submit Return Request';
                        return;
                    }

                    formData.return_contact_name = name;
                    formData.return_contact_phone = contact;
                    formData.return_pickup_address = address;
                } else {
                    // Use original address data instead of parsing from DOM
                    if (!originalAddress.name || !originalAddress.phone || !originalAddress.address || 
                        originalAddress.name === 'Not Available' || 
                        originalAddress.phone === 'Not Available' || 
                        originalAddress.address === 'Not Available') {
                        alert('Existing address is incomplete. Please provide a new address.');
                        button.disabled = false;
                        button.textContent = 'Submit Return Request';
                        return;
                    }
                    
                    formData.return_contact_name = originalAddress.name;
                    formData.return_contact_phone = originalAddress.phone;
                    formData.return_pickup_address = originalAddress.address;
                }

                const urlParams = new URLSearchParams(window.location.search);
                const email = urlParams.get('email');
                
                const response = await fetch(`${API_BASE_URL}/api/rentals/customer/public/return/${rentalId}/?email=${encodeURIComponent(email)}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData)
                });

                const data = await response.json();

                if (response.ok) {
                    const urlParams = new URLSearchParams(window.location.search);
                    const email = urlParams.get('email');
                    
                    try {
                        // Use the correct URL endpoint
                        const statusResponse = await fetch(
                            `${API_BASE_URL}/api/rentals/customer/public/return-details/${rentalId}/?email=${encodeURIComponent(email)}`
                        );
                        
                        if (!statusResponse.ok) {
                            console.error('Status response error:', await statusResponse.text());  // Debug log
                            throw new Error('Failed to fetch rental details');
                        }
                        
                        const statusData = await statusResponse.json();
                        console.log('Status data received:', statusData);  // Debug log
                        showSuccessMessage('Return request submitted successfully', statusData);
                    } catch (error) {
                        console.error('Error fetching rental details:', error);
                        // Show a basic success message if we can't get the detailed status
                        showSuccessMessage('Return request submitted successfully', {
                            rental_id: rentalId,
                            product_name: data.product_name
                        });
                    }
                } else {
                    throw new Error(data.error || 'Failed to submit return request');
                }
            } catch (error) {
                console.error('Error:', error);
                showErrorMessage(error.message || 'Failed to submit return request');
            } finally {
                button.disabled = false;
                button.textContent = 'Submit Return Request';
            }
        });
    }

    function showSuccessMessage(message, data) {
        const container = document.querySelector('.rental-return-container');
        
        const statusHTML = `
            <div class="rental-status">
                <h1 class="order-id">Order ID: RNT${data.rental_id}</h1>
                
                <div class="product-info">
                    <img src="${data.product_image || ''}" alt="${data.product_name}" class="product-image">
                    <h2>${data.product_name}</h2>
                </div>

                <div class="rental-details">
                    <div class="detail-row">
                        <div class="detail-col">
                            <span class="label">Rented for:</span>
                            <span class="value">${data.rental_period || 'N/A'}</span>
                        </div>
                        <div class="detail-col">
                            <span class="label">Subscription Started:</span>
                            <span class="value">${data.subscription_start || 'N/A'}</span>
                        </div>
                    </div>

                    <div class="detail-row">
                        <div class="detail-col">
                            <span class="label">Total Rent:</span>
                            <span class="value">₹${data.total_rent || '0'}</span>
                        </div>
                        <div class="detail-col">
                            <span class="label">Subscription End:</span>
                            <span class="value">${data.subscription_end || 'N/A'}</span>
                        </div>
                    </div>

                    <div class="detail-row">
                        <div class="detail-col">
                            <span class="label">Refundable Deposit:</span>
                            <span class="value">₹${data.refundable_deposit || '0'}</span>
                        </div>
                        <div class="detail-col">
                            <span class="label">Order Status:</span>
                            <span class="value status-return">Return Requested</span>
                        </div>
                    </div>
                </div>

                <div class="tenure-section">
                    <h3>Tenure Progress</h3>
                    <div class="timeline">
                        <div class="progress-bar-container" style="
                            width: 100%;
                            height: 8px;
                            background-color: #f0f0f0;
                            border-radius: 4px;
                            position: relative;
                            overflow: hidden;
                            margin: 10px 0;
                        ">
                            <div class="progress-bar" style="
                                position: absolute;
                                display: block !important;
                                left: 0;
                                top: 0;
                                height: 100%;
                                width: ${calculateProgress(data)}%;
                                background-color: #FF4444;
                                border-radius: 4px;
                                transition: width 0.3s ease;
                            "></div>
                        </div>
                        <div class="days-left">${data.days_left} days remaining</div>
                    </div>
                </div>

                <div class="next-steps">
                    <h3>Next Steps:</h3>
                    <button class="initiate-return-btn" onclick="initiateReturn('${data.return_id}')">
                        Upload Quality Check Images
                    </button>
                </div>

                <div class="download-section">
                    <a href="${data.invoice_url || '#'}" class="download-link">
                        <i class="download-icon"></i>
                        Download Rental Invoice
                    </a>
                </div>

                <div class="support-text">
                    If you have any queries, write to <a href="mailto:wonderent@wonderchef.in">wonderent@wonderchef.in</a>
                    to get in touch with our support team.
                </div>

                <!-- Add drawer HTML -->
                <div id="qcDrawer" class="qc-drawer">
                    <div class="drawer-content">
                        <div class="drawer-header">
                            <h2>Upload Quality Check Images</h2>
                            <button class="close-drawer" onclick="closeDrawer()">&times;</button>
                        </div>
                        
                        <div class="drawer-body">
                            <div class="upload-section">
                                <!-- Front Image -->
                                <div class="upload-box" id="frontImageBox">
                                    <input type="file" id="frontImage" accept="image/*" hidden>
                                    <div class="upload-placeholder" onclick="document.getElementById('frontImage').click()">
                                        <i class="upload-icon">📷</i>
                                        <p>Upload Front Image*</p>
                                    </div>
                                    <div class="preview-container" style="display: none;">
                                        <img id="frontPreview" src="" alt="Front Preview">
                                        <button class="remove-image" onclick="removeImage('front')">×</button>
                                    </div>
                                </div>

                                <!-- Back Image -->
                                <div class="upload-box" id="backImageBox">
                                    <input type="file" id="backImage" accept="image/*" hidden>
                                    <div class="upload-placeholder" onclick="document.getElementById('backImage').click()">
                                        <i class="upload-icon">📷</i>
                                        <p>Upload Back Image*</p>
                                    </div>
                                    <div class="preview-container" style="display: none;">
                                        <img id="backPreview" src="" alt="Back Preview">
                                        <button class="remove-image" onclick="removeImage('back')">×</button>
                                    </div>
                                </div>

                                <!-- Left Image -->
                                <div class="upload-box" id="leftImageBox">
                                    <input type="file" id="leftImage" accept="image/*" hidden>
                                    <div class="upload-placeholder" onclick="document.getElementById('leftImage').click()">
                                        <i class="upload-icon">📷</i>
                                        <p>Upload Left Image*</p>
                                    </div>
                                    <div class="preview-container" style="display: none;">
                                        <img id="leftPreview" src="" alt="Left Preview">
                                        <button class="remove-image" onclick="removeImage('left')">×</button>
                                    </div>
                                </div>

                                <!-- Right Image -->
                                <div class="upload-box" id="rightImageBox">
                                    <input type="file" id="rightImage" accept="image/*" hidden>
                                    <div class="upload-placeholder" onclick="document.getElementById('rightImage').click()">
                                        <i class="upload-icon">📷</i>
                                        <p>Upload Right Image*</p>
                                    </div>
                                    <div class="preview-container" style="display: none;">
                                        <img id="rightPreview" src="" alt="Right Preview">
                                        <button class="remove-image" onclick="removeImage('right')">×</button>
                                    </div>
                                </div>

                                <!-- Top Image -->
                                <div class="upload-box" id="topImageBox">
                                    <input type="file" id="topImage" accept="image/*" hidden>
                                    <div class="upload-placeholder" onclick="document.getElementById('topImage').click()">
                                        <i class="upload-icon">📷</i>
                                        <p>Upload Top Image*</p>
                                    </div>
                                    <div class="preview-container" style="display: none;">
                                        <img id="topPreview" src="" alt="Top Preview">
                                        <button class="remove-image" onclick="removeImage('top')">×</button>
                                    </div>
                                </div>

                                <!-- Bottom Image -->
                                <div class="upload-box" id="bottomImageBox">
                                    <input type="file" id="bottomImage" accept="image/*" hidden>
                                    <div class="upload-placeholder" onclick="document.getElementById('bottomImage').click()">
                                        <i class="upload-icon">📷</i>
                                        <p>Upload Bottom Image*</p>
                                    </div>
                                    <div class="preview-container" style="display: none;">
                                        <img id="bottomPreview" src="" alt="Bottom Preview">
                                        <button class="remove-image" onclick="removeImage('bottom')">×</button>
                                    </div>
                                </div>

                                <!-- Defect Image (Optional) -->
                                <div class="upload-box" id="defectImageBox">
                                    <input type="file" id="defectImage" accept="image/*" hidden>
                                    <div class="upload-placeholder" onclick="document.getElementById('defectImage').click()">
                                        <i class="upload-icon">📷</i>
                                        <p>Upload Defect Image (if any)</p>
                                    </div>
                                    <div class="preview-container" style="display: none;">
                                        <img id="defectPreview" src="" alt="Defect Preview">
                                        <button class="remove-image" onclick="removeImage('defect')">×</button>
                                    </div>
                                </div>

                                <!-- Additional Images (Optional) -->
                                <div class="upload-box" id="additionalImageBox">
                                    <input type="file" id="additionalImage" accept="image/*" hidden>
                                    <div class="upload-placeholder" onclick="document.getElementById('additionalImage').click()">
                                        <i class="upload-icon">📷</i>
                                        <p>Upload Additional Images (if any)</p>
                                    </div>
                                    <div class="preview-container" style="display: none;">
                                        <img id="additionalPreview" src="" alt="Additional Preview">
                                        <button class="remove-image" onclick="removeImage('additional')">×</button>
                                    </div>
                                </div>
                            </div>

                            <div class="upload-actions">
                                <button class="submit-upload" onclick="submitQCImages()">Submit Images</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Add success overlay -->
                <div id="successOverlay" class="success-overlay">
                    <div class="success-content">
                        <div class="success-icon">✓</div>
                        <h2>Images Uploaded Successfully</h2>
                        <p>Our team will review the images and process your return request.</p>
                        <button class="close-success" onclick="closeSuccessOverlay()">Close</button>
                    </div>
                </div>
            </div>
        `;

        container.innerHTML = statusHTML;
        setupImageUploadHandlers();
    }

    function showErrorMessage(message) {
        const container = document.querySelector('.rental-return-container');
        container.innerHTML = `
            <div class="return-form-card">
                <h1 class="return-title">Error</h1>
                <p class="return-description">${message}</p>
                <button onclick="window.location.reload()" class="submit-button">Try Again</button>
            </div>
        `;
    }
});

async function handleReturnFormSubmission(event) {
    event.preventDefault();
    const form = event.target;
    const rentalId = form.dataset.rentalId;
    
    // Get form data
    const formData = {
        name: form.querySelector('[name="name"]').value,
        phone: form.querySelector('[name="phone"]').value,
        address: form.querySelector('[name="address"]').value,
        // ... other form fields
    };

    try {
        const response = await fetch(`${API_BASE_URL}/api/rentals/customer/public/return/${rentalId}/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        });

        const data = await response.json();

        if (response.ok) {
            // Replace form with return status page
            showReturnStatus(data);
        } else {
            throw new Error(data.error || 'Failed to submit return request');
        }
    } catch (error) {
        console.error('Error:', error);
        alert('Failed to submit return request. Please try again.');
    }
}

function showReturnStatus(data) {
    const container = document.querySelector('.rental-details-container');
    
    const statusHTML = `
        <div class="rental-status">
            <h1 class="order-id">Order ID: ${data.order_id}</h1>
            
            <div class="product-info">
                <img src="${data.product_image}" alt="${data.product_name}" class="product-image">
                <h2>${data.product_name}</h2>
            </div>

            <div class="rental-details">
                <div class="detail-row">
                    <div class="detail-col">
                        <span class="label">Rented for:</span>
                        <span class="value">${data.rental_period}</span>
                    </div>
                    <div class="detail-col">
                        <span class="label">Subscription Started:</span>
                        <span class="value">${data.subscription_start}</span>
                    </div>
                </div>

                <div class="detail-row">
                    <div class="detail-col">
                        <span class="label">Total Rent:</span>
                        <span class="value">₹${data.total_rent}</span>
                    </div>
                    <div class="detail-col">
                        <span class="label">Subscription End:</span>
                        <span class="value">${data.subscription_end}</span>
                    </div>
                </div>

                <div class="detail-row">
                    <div class="detail-col">
                        <span class="label">Refundable Deposit:</span>
                        <span class="value">₹${data.refundable_deposit}</span>
                    </div>
                    <div class="detail-col">
                        <span class="label">Order Status:</span>
                        <span class="value status-return">Return Requested</span>
                    </div>
                </div>
            </div>

            <div class="tenure-section">
                <h3>Tenure Progress</h3>
                <div class="timeline">
                    <div class="progress-bar-container" style="
                        width: 100%;
                        height: 8px;
                        background-color: #f0f0f0;
                        border-radius: 4px;
                        position: relative;
                        overflow: hidden;
                        margin: 10px 0;
                    ">
                        <div class="progress-bar" style="
                            position: absolute;
                            left: 0;
                            top: 0;
                            height: 100%;
                            width: ${calculateProgress(data)}%;
                            background-color: #FF4444;
                            border-radius: 4px;
                            transition: width 0.3s ease;
                        "></div>
                    </div>
                    <div class="days-left">${data.days_left}</div>
                </div>
            </div>

            <div class="next-steps">
                <h3>Next Steps:</h3>
                <button class="initiate-return-btn" onclick="initiateReturn('${data.return_id}')">
                    Initiate Return - Upload Quality Check Images
                </button>
            </div>

            <div class="download-section">
                <a href="${data.invoice_url}" class="download-link">
                    <img src="{{ 'download-icon.svg' | asset_url }}" alt="Download">
                    Download Rental Invoice
                </a>
            </div>

            <div class="support-text">
                If you have any queries, write to <a href="mailto:wonderent@wonderchef.in">wonderent@wonderchef.in</a>
                to get in touch with our support team.
            </div>
        </div>
    `;

    container.innerHTML = statusHTML;
}

function initiateReturn(returnId) {
    document.getElementById('qcDrawer').classList.add('open');
}

function closeDrawer() {
    document.getElementById('qcDrawer').classList.remove('open');
}

function setupImageUploadHandlers() {
    ['front', 'back', 'left', 'right', 'top', 'bottom', 'defect', 'additional'].forEach(type => {
        const input = document.getElementById(`${type}Image`);
        input.addEventListener('change', (e) => handleImageUpload(e, type));
    });
}

function handleImageUpload(event, type) {
    const file = event.target.files[0];
    if (file) {
        const reader = new FileReader();
        reader.onload = function(e) {
            const previewImg = document.getElementById(`${type}Preview`);
            const previewContainer = document.querySelector(`#${type}ImageBox .preview-container`);
            const placeholder = document.querySelector(`#${type}ImageBox .upload-placeholder`);
            
            previewImg.src = e.target.result;
            previewContainer.style.display = 'block';
            placeholder.style.display = 'none';
        }
        reader.readAsDataURL(file);
    }
}

function removeImage(type) {
    const input = document.getElementById(`${type}Image`);
    const previewContainer = document.querySelector(`#${type}ImageBox .preview-container`);
    const placeholder = document.querySelector(`#${type}ImageBox .upload-placeholder`);
    
    input.value = '';
    previewContainer.style.display = 'none';
    placeholder.style.display = 'flex';
}

async function submitQCImages() {
    const button = document.querySelector('.submit-upload');
    button.disabled = true;
    button.textContent = 'Uploading...';

    try {
        const requiredImages = ['front', 'back', 'left', 'right', 'top', 'bottom'];
        const formData = new FormData();
        
        // Check required images
        for (const type of requiredImages) {
            const file = document.getElementById(`${type}Image`).files[0];
            if (!file) {
                alert(`Please upload ${type} image`);
                button.disabled = false;
                button.textContent = 'Submit Images';
                return;
            }
            formData.append(`${type}_image`, file);
        }

        // Optional images
        const defectFile = document.getElementById('defectImage').files[0];
        const additionalFile = document.getElementById('additionalImage').files[0];

        if (defectFile) {
            formData.append('defect_image', defectFile);
        }
        if (additionalFile) {
            formData.append('additional_images', additionalFile);
        }

        const urlParams = new URLSearchParams(window.location.search);
        const email = urlParams.get('email');
        const rentalId = urlParams.get('rental_id')?.replace('RNT', '');

        const response = await fetch(
            `${API_BASE_URL}/api/rentals/customer/public/upload-qc-images/${rentalId}/?email=${encodeURIComponent(email)}`,
            {
                method: 'POST',
                body: formData
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Failed to upload images');
        }

        const data = await response.json();
        showUploadSuccess();

    } catch (error) {
        console.error('Upload error:', error);
        alert(error.message || 'Failed to upload images. Please try again.');
    } finally {
        button.disabled = false;
        button.textContent = 'Submit Images';
    }
}

function showUploadSuccess() {
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get('email');
    const originalOrderId = urlParams.get('original_order_id');
    const rentalId = urlParams.get('rental_id')?.replace('RNT', '');

    // Show brief success message
    const container = document.querySelector('.rental-return-container');
    container.innerHTML = `
        <div class="return-form-card">
            <h1 class="return-title">Images Uploaded Successfully</h1>
            <p class="return-description">Redirecting to your order details...</p>
        </div>
    `;

    // Redirect after a short delay (2 seconds)
    setTimeout(() => {
        window.location.href = `/pages/rental-order?order_id=${originalOrderId}&email=${encodeURIComponent(email)}`;
    }, 2000);
}

function closeSuccessOverlay() {
    document.getElementById('successOverlay').classList.remove('show');
    closeDrawer();
}

function calculateProgress(data) {
    const startDate = new Date(data.subscription_start);
    const endDate = new Date(data.subscription_end);
    const today = new Date();

    const totalDays = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
    const elapsedDays = Math.ceil((today - startDate) / (1000 * 60 * 60 * 24));
    return Math.min(Math.max((elapsedDays / totalDays) * 100, 0), 100);
}
